/* eslint-disable react-hooks/exhaustive-deps */
import { Select } from 'antd';
import { useTranslation } from 'react-i18next';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import Style from './style';
import Table from './table';
import Widget from '../../widget';
import KycModal from './components/KycModal';
import { getLocales } from '../../../../components/Table/newTable';

export default function TableComponents({
  data = { tabs: {}, data: {} },
  changeKey = null,
  setChangeKey = () => { },
  filterKey = null,
  setFilterKey = () => { },
  loading,
}) {
  const { t } = useTranslation();
  const [activeKey, setActiveKey] = useState(Object.keys(data.tabs)[0]);
  const tableRef = useRef();
  const [activeCheck, setActiveCheck] = useState();

  useEffect(() => {
    if (filterKey) {
      switch (filterKey) {
        case '8c':
          if (data?.tabs?.checks) {
            setActiveKey('checks');
          }
          break;
        case '9c':
          if (data?.tabs?.documentationChecks) {
            setActiveKey('documentationChecks');
          }
          break;
        case '10c':
          if (data?.tabs?.riskReadiness) {
            setActiveKey('riskReadiness');
          }
          break;
        case '11c':
          if (data?.tabs?.challenges) {
            setActiveKey('challenges');
          }
          break;
        default:
      }
      setFilterKey(null);
    }
  }, [filterKey]);

  useEffect(() => {
    setActiveKey(Object.keys(data.tabs)[0]);
  }, [data]);

  useEffect(() => {
    if (typeof changeKey === 'string') {
      setActiveKey(changeKey);
      setChangeKey(null);
    }
  }, [changeKey]);

  const actions = useMemo(() => ({
    setActiveCheck,
  }), []);

  return (
    <Widget
      className="no-px-body no-pb-header no-min-width"
      title={t('Assessment Details')}
      header={activeKey ? (
        <div className="flex-1 flex justify-content-end">
          <Select
            className="custom-select"
            onChange={setActiveKey}
            value={activeKey}
            style={{ width: 200 }}
          >
            {Object.entries(data.tabs).map(([k, d]) => (
              <Select.Option value={k} key={k}>
                {t(d.label)}
              </Select.Option>
            ))}
          </Select>
        </div>
      ) : null}
      loading={loading}
    >
      <Style id="sca-table-components" ref={tableRef} className={activeKey}>
        {loading ? null : Object.entries(data.tabs).map(([k, d]) => (
          <div style={{ display: activeKey === k ? 'block' : 'none' }} key={k}>
            <Table
              locale={getLocales(t)}
              actions={actions}
              data={data.data[activeKey]}
              t={t}
              k={activeKey}
            />
          </div>
        ))}
      </Style>
      <KycModal
        data={data?.data?.checks}
        activeCheck={activeCheck}
        onCancel={() => setActiveCheck(null)}
      />
    </Widget>
  );
}
